import { Component, OnInit } from '@angular/core';
import { TestGroup } from 'src/app/models/custom_test_model';
import { CustomTestService } from 'src/app/services/custom-test.service';
import { UserService } from 'src/app/services/user.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-test-groups',
  templateUrl: './test-groups.component.html',
  styleUrls: ['./test-groups.component.css']
})
export class TestGroupsComponent implements OnInit {

  public groups: TestGroup[] = []
  public user

  constructor(
    private customTestService: CustomTestService,
    private userService: UserService
  ) { }

  async ngOnInit() {
    this.user = await this.userService.getUser().toPromise()
    let query = {}
    if (this.user.role != 'admin'){
      query = {
        userId: this.user._id
      }
    }
    this.customTestService.getTestGroups(query).subscribe(
      (response: TestGroup[]) => {
        this.groups = response
      },
      error => {
        console.log(error)
      }
    )
  }

  async handleDelete(id: string){
    let response = await Swal.fire({
      title: '¿Estás seguro de que deseas eliminar este grupo?',
      text: 'Esta acción no se puede deshacer',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Eliminar',
      cancelButtonText: 'Cancelar'
    })

    if (!response.isConfirmed) return

    this.customTestService.deleteTestGroup(id).subscribe(
      response => {
        Swal.fire({
          text: 'El grupo ha sido eliminado exitosamente',
          icon: 'success',
          confirmButtonText: 'Aceptar'
        })
        this.groups = this.groups.filter(group => group._id !== id)
      },
      error => {
        console.log(error)
      }
    )
  }

  toggleVisibility(group: TestGroup){
    this.customTestService.updateTestGroup({active: !group.active}, group._id).subscribe(
      response => {
        group.active = !group.active
      },
      error => {
        console.log(error)
      }
    )
  }

}
